module.exports = __webpack_public_path__ + "media/images/icons/SVG/006-d75b7d69928897527dabd29bd5161b1a.svg";